import { useState, useMemo } from 'react';
import __isEmpty from 'lodash/isEmpty';
import styles from './manualoperadors.module.scss';
import Enllac from 'components/corporatiu/Enllac';
import Text from 'components/corporatiu/Text';
import Boto from 'components/corporatiu/Boto';
import Imatge from 'components/corporatiu/Imatge';
import clsx from 'clsx';

export default function ManualOperadors(props) {
    const { items, lang } = props;
    const captchaRandom = useMemo(() => Math.random(), []);
    const [basesChecked, setBasesChecked] = useState(false);

    const stylesBoto = clsx({
        [styles.botoEnvia]: true,
        [styles.disabled]: basesChecked === false
    });

    const urlOk = `/corporatiu/${lang}/manual-operadors-plataformes-distribucio-video/ok/`;
    const urlKo = `/corporatiu/${lang}/manual-operadors-plataformes-distribucio-video/ko/`;

    return (
        <>
            <Text text={items?.entradeta} />
            <div className={styles.contentForm}>
                <form
                    action='https://www.3cat.cat/su/Register'
                    method='post'
                    name='Participa'
                    encType='multipart/form-data'
                    id='Participa'
                >
                    <fieldset>
                        <label htmlFor='NOM'>{items?.form[0].nom}:</label>
                        <input id='NOM' type='text' name='NOM' required={true} />
                    </fieldset>
                    <fieldset>
                        <label htmlFor='EMPRESA'>{items?.form[0].empresa}:</label>
                        <input id='EMPRESA' type='text' name='EMPRESA' required={true} />
                    </fieldset>
                    <fieldset>
                        <label htmlFor='CORREU'>{items?.form[0].correu}:</label>
                        <input id='CORREU' type='email' name='CORREU' required={true} />
                    </fieldset>
                    <fieldset>
                        <label htmlFor='TEXT'>{items?.form[0].text}:</label>
                        <textarea id='TEXT' cols='10' rows='6' name='TEXT' required={true}></textarea>
                        <input type='hidden' id='TEXTMAIL' name='DIV_TEXTMAIL' value='' />
                    </fieldset>
                    <fieldset>
                        <label htmlFor='IMGID'>{items?.form[0].captcha}:</label>
                        <div className='img_captcha'>
                            <Imatge
                                src={`https://www.3cat.cat/su/shared/image.jsp?imgId=${captchaRandom}`}
                                loading='lazy'
                                alt='Imatge del codi captcha'
                                width={107}
                                height={29}
                            />

                            <input value='IMGID' id='hiImgNumber' name='hiImgNumber' type='hidden' />
                            <input name='IMGID' id='IMGID' type='text' className='camp_captcha' required={true} />
                        </div>
                    </fieldset>

                    <fieldset>
                        <label htmlFor='bases'>
                            <input
                                type='checkbox'
                                name='bases'
                                id='bases'
                                className='campCheck'
                                required={true}
                                onChange={(e) => setBasesChecked(e.target.checked)}
                            />
                            {items?.form[0].accepto}{' '}
                            <Enllac
                                href='https://www.3cat.cat/avis-legal/privacitat/compromis/'
                                title='TV3 - Televisió de Catalunya'
                            >
                                {items?.form[0].legal}
                            </Enllac>
                        </label>
                    </fieldset>

                    <Boto
                        type='submit'
                        id='accept'
                        text={items?.form[0].envia}
                        estil='ple3cat100'
                        tag='button'
                        className={stylesBoto}
                        disabled={!basesChecked}
                        aria-hidden={!basesChecked}
                    />

                    <input name='hiTarget' type='hidden' value={urlOk} />
                    <input name='hiErrTarget' type='hidden' value={urlKo} />
                    <input type='hidden' name='hiRegServiceId' value='CCMA_MANUAL_US' />
                    <input type='hidden' name='hiServiceId' value='CCMA_MANUAL_US' />
                    <input type='hidden' name='hiAction' value='254' />
                    <input type='hidden' name='IDIOMA' value={lang} />
                </form>
            </div>
        </>
    );
}
